"use strict";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

function dupe_array(count, value, i) {
  var c = count[i] | 0;

  if (c <= 0) {
    return [];
  }

  var result = new Array(c),
      j;

  if (i === count.length - 1) {
    for (j = 0; j < c; ++j) {
      result[j] = value;
    }
  } else {
    for (j = 0; j < c; ++j) {
      result[j] = dupe_array(count, value, i + 1);
    }
  }

  return result;
}

function dupe_number(count, value) {
  var result, i;
  result = new Array(count);

  for (i = 0; i < count; ++i) {
    result[i] = value;
  }

  return result;
}

function dupe(count, value) {
  if (typeof value === "undefined") {
    value = 0;
  }

  switch (_typeof(count)) {
    case "number":
      if (count > 0) {
        return dupe_number(count | 0, value);
      }

      break;

    case "object":
      if (typeof count.length === "number") {
        return dupe_array(count, value, 0);
      }

      break;
  }

  return [];
}

module.exports = dupe;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(dupe_array, "dupe_array", "/home/yatham/Dev_BHS_Portal/node_modules/dup/dup.js");
  reactHotLoader.register(dupe_number, "dupe_number", "/home/yatham/Dev_BHS_Portal/node_modules/dup/dup.js");
  reactHotLoader.register(dupe, "dupe", "/home/yatham/Dev_BHS_Portal/node_modules/dup/dup.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();